// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MmsiM","select":"styles_select__nKX+b","label":"styles_label__OXaTd","asterisk":"styles_asterisk__UTTJW","error":"styles_error__1dKfl"};